module.exports = __webpack_public_path__ + "static/media/Spinner.a90e737d.gif";